import track from '../lib/event';
import config from '../config';

export default {
  emited: (binding) => {
    const { eventTrack } = config;
    if (!Object.prototype.hasOwnProperty.call(eventTrack, 'enable') || !eventTrack.enable) return;
    if (binding.isIgnoreTrackRequest) return;
    track.event(binding);
  },
};
